import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

import {ItemKey} from "../item/core/ItemKey";
import {SearchModel} from "../search/SearchModel";
import {Tile} from "@/modules/redactor/models/utils/Tile";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import { RewardModel } from "@/modules/redactor/models/reward/RewardModel";
import {TriggerUtils} from "@/modules/redactor/models/trigger/core/TriggerUtils";
import {WorldRegionWonderModel} from "@/modules/redactor/models/world-region/wonder/WorldRegionWonderModel";

export class WorldRegion extends BaseObject {

    constructor() {
        super();

        this._region = 0;

        this._gameLevel = 0;
        this._userLevel = 0;

        this._search = null;

        this._tiles = [];
        this._money = [];
        this._blocker = null;
        this._triggers = [];

        this._reward = null;
        this._wonders = [];
    }

    get region() {
        return this._region;
    }

    set region(value) {
        this._region = value;
    }

    get search() {
        return this._search;
    }

    set search(value) {
        this._search = value;
    }

    get tiles() {
        return this._tiles;
    }

    set tiles(value) {
        this._tiles = value;
    }

    get money() {
        return this._money;
    }

    set money(value) {
        this._money = value;
    }

    get blocker() {
        return this._blocker;
    }

    set blocker(value) {
        this._blocker = value;
    }

    get userLevel() {
        return this._userLevel;
    }

    set userLevel(value) {
        this._userLevel = value;
    }

    get gameLevel() {
        return this._gameLevel;
    }

    set gameLevel(value) {
        this._gameLevel = value;
    }

    get triggers() {
        return this._triggers;
    }

    set triggers(value) {
        this._triggers = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get wonders() {
        return this._wonders;
    }

    set wonders(value) {
        this._wonders = value;
    }

    valid() {

        if (!Number.isInteger(this.region) || this.region < 0) {
            return false;
        }

        if (this.search && !this.search.valid()) {
            return false;
        }

        if (this.tiles && this.tiles.some(v => !v.valid())) {
            return false;
        }

        if (this.money && this.money.some(v => !v || !v.valid() || v.free())) {
            return false;
        }

        if (this.money && this.money.length > 1) {
            return false;
        }

        if (this.blocker && (!this.blocker.valid() || this.blocker.any())) {
            return false;
        }

        if (!Number.isInteger(this.gameLevel) || this.gameLevel < 0) {
            return false;
        }

        if (!Number.isInteger(this.userLevel) || this.userLevel < 0) {
            return false;
        }

        if (this.triggers && this.triggers.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorldRegion());
        } else if (target instanceof WorldRegion) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(WorldRegion, {
    _region: alias("region", Schema.primitive()),
    _search: alias("search", SearchModel.schema()),
    _tiles: alias("tiles", list(Tile.schema())),
    _money: alias("money", list(Currency.schema())),
    _blocker: alias("blocker", ItemKey.schema()),
    _triggers: alias("triggers", TriggerUtils.schema()),
    _gameLevel: alias("game_level", Schema.primitive()),
    _userLevel: alias("user_level", Schema.primitive()),
    _reward: alias("reward", RewardModel.schema()),
    _wonders: alias("wonders", list(WorldRegionWonderModel.schema())),
});